function toCustomPropertyName(key) {
  return `--ifl-${key.replace("-[base]", "")}`;
}
function toCustomPropertyValue(key) {
  return `var(${toCustomPropertyName(key)})`;
}
function createColorProperties(obj, objParentName) {
  let properties = {};
  Object.keys(obj).forEach(key => {
    const value = obj[key];
    const name = `${objParentName}-${key}`;
    if (value && typeof value === "object") {
      properties = {
        ...properties,
        ...createColorProperties(value, name)
      };
    } else {
      properties[toCustomPropertyName(name)] = value;
    }
  });
  return properties;
}
function createCustomPropertyTheme(theme) {
  const {
    colors: rawColors = {},
    ...remainingTheme
  } = theme;
  const colorsAsCustomProperties = rawValuesToCustomProperties(rawColors, "colors");
  return {
    ...remainingTheme,
    colors: colorsAsCustomProperties,
    rawColors
  };
}
function rawValuesToCustomProperties(obj, objParentName) {
  const references = {};
  Object.keys(obj).forEach(key => {
    const value = obj[key];
    const name = `${objParentName}-${key}`;
    if (value && typeof value === "object") {
      references[key] = rawValuesToCustomProperties(value, name);
    } else {
      references[key] = toCustomPropertyValue(name);
    }
  });
  return references;
}
function isIndeedTheme(theme) {
  return theme._themeName === "indeed";
}

export { createColorProperties, createCustomPropertyTheme, isIndeedTheme };
